import { Component, OnInit } from '@angular/core';

import{HttpClient} from '@angular/common/http'

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.css']
})
export class ReviewsComponent implements OnInit {

  posts:object;

  constructor( private http:HttpClient) { }

  ngOnInit(): void {
    //this.http.get('https://mybusiness.googleapis.com/v4/accounts/249529736102-hk7cdu709ulrgk4g8mn41k8h53mecquh.apps.googleusercontent.com/locations/ChIJaXInkBWJr44RWHlA7yAGdyA/reviews').subscribe((data)=>console.log(data));
  }

  displayPos(data:object){
    this.posts=data;
  }
}

